import messages from 'vee-validate/dist/locale/en';

export default {
    messages: {
        ...messages.messages,
        login() {
            return 'Incorrect username or password.';
        },
        unique() {
            return 'Email already exists';
        },
        enabled() {
            return 'The specified user has been disabled.';
        },
        locked() {
            return 'Your access has been restricted. Please contact your Manager.';
        },
        userNotExists() {
            return 'We couldn\'t find that email. Please try another one';
        },
    },
    attributes: {
        name: 'name',
        email: 'email',
        password: 'password',
        passwordConfirmation: 'confirm password',
    },
};



// WEBPACK FOOTER //
// ./src/lang/en/validator.js